import React, { useState } from 'react';
import PropTypes from 'prop-types';

import styles from './EventDataTable.module.css';

import DefaultHeaderCell from 'components/admin/DefaultHeaderCell';

// Presentational table for the meet results list. Filtering and the Event
// View / Age View switch live in the Events page's filter row, so this
// receives already-filtered rows and only owns column sorting.
const EventDataTable = ({
  data = [],
  columns,
  headStyle,
  rowStyle,
  tableStyle,
  emptyState = null,
}) => {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  const sortedData = [...data].sort((a, b) => {
    if (sortConfig.key) {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    }
    return 0;
  });

  const handleSort = (key) => {
    setSortConfig((prevConfig) => {
      if (prevConfig.key === key) {
        return {
          key,
          direction: prevConfig.direction === 'asc' ? 'desc' : 'asc',
        };
      }
      return { key, direction: 'asc' };
    });
  };

  return (
    <div className={styles.tableContainer}>
      <div className={styles.table} style={tableStyle}>
        <div className={styles.rows}>
          <div className={styles.row} style={headStyle}>
            {columns.map((column, index) => {
              return (
                <DefaultHeaderCell
                  key={index}
                  column={column}
                  sortConfig={sortConfig}
                  handleSort={handleSort}
                />
              );
            })}
          </div>
          {sortedData.length === 0 && emptyState ? (
            <div className={styles.emptyState}>{emptyState}</div>
          ) : (
            sortedData.map((row, i) => (
              <div key={i} className={styles.row} style={rowStyle}>
                {columns.map((column, i) => (
                  <div key={i} className={styles.cell} style={column.style}>
                    {column.Cell ? column.Cell(row) : row[column.accessor]}
                  </div>
                ))}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

EventDataTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object),
  data: PropTypes.arrayOf(PropTypes.object),
  headStyle: PropTypes.object,
  rowStyle: PropTypes.object,
  tableStyle: PropTypes.object,
  emptyState: PropTypes.node,
};

export default EventDataTable;
